import React from 'react'
import { useFormContext } from 'react-hook-form'
import { TextInput } from '@/components/ui/ReactHookFormFields'
import { messages } from './messages'
import './styles.scss'

export const FinancingUxFeedbackModalFormComment = () => {
  const { control } = useFormContext()

  return (
    <div className="financingUxFeedbackModalFormComment">
      <div className="financingUxFeedbackModalFormComment__heading">{messages.comment}</div>
      <TextInput
        type="textArea"
        control={control}
        name="comment"
        textAreaRows={6}
        placeholder={messages.placeholder}
        textAreaAutosize={false}
        maxLength={2190}
      />
    </div>
  )
}
